var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-sm-12 col-md-10 col-lg-8 app-status"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":`./svg/${_vm.img}`,"alt":_vm.content.headline}})]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content.status_message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }